import { useEffect, useState } from 'react';
import { NewsItem } from '../../types/common';
import { FaChevronDown } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

export default function NewsSection() {
  const [news, setNews] = useState<NewsItem[]>([]);
  const [isNewsExpanded, setIsNewsExpanded] = useState(false);
  const { t } = useTranslation();
  const NEWS_LIMIT_COUNT = 8;
  const newsExpandAnimation = `overflow-hidden transition-[max-height] duration-500 ease-in-out ${isNewsExpanded ? 'max-h-[600px]' : 'max-h-[300px]'}`;

  useEffect(() => {
    fetch('/data/news.json')
      .then((res) => res.json())
      .then((data: NewsItem[]) => {
        const sortedNews = data.sort(
          (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
        );
        setNews(sortedNews.slice(0, NEWS_LIMIT_COUNT));
      })
      .catch((error) => console.error('Failed to fetch news:', error));
  }, []);

  return (
    <section id="news" className="py-[100px] overflow-hidden bg-white">
      <div className="w-full max-w-[1280px] mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-center text-[#1C2028]">News</h2>
        <div className={`mt-12 ${newsExpandAnimation}`}>
          <div className="flex justify-end">
            <button
              className="flex gap-2 p-2 mr-2"
              onClick={() => setIsNewsExpanded((prev) => !prev)}
            >
              <span className="text-lg">
                {isNewsExpanded ? t('News.hide') : t('News.showMore')}
              </span>
              <div className="flex items-center justify-between transition duration-200 h-full">
                <span
                  className={`transition-transform ${isNewsExpanded ? 'rotate-180' : 'rotate-0'}`}
                >
                  <FaChevronDown className="w-4 h-4 md:w-5 md:h-5" />
                </span>
              </div>
            </button>
          </div>
          <ul className="mt-2 border-t border-gray-300">
            {news.map((item) => (
              <li key={item.link} className="border-b border-gray-300 py-4">
                <a
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex justify-between items-center text-[#1C2028] hover:text-primary transition-colors"
                >
                  <div className="flex gap-4 w-full px-4">
                    <div className="font-medium text-lg leading-[28px] truncate flex-1">
                      {item.title}
                    </div>
                    <div className="font-normal text-base leading-[22.4px] text-gray-500 w-[fit-content] flex items-center hidden sm:block">
                      {item.date}
                    </div>
                  </div>
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
